<template>
  <div class="add-popup-component" :style="height">
    <div class="add-popup-container" ref="addPopup">
      <div class="global_popup_header">
        {{ title }}<i @click="$store.commit('windowHandle')"></i>
      </div>
      <div class="add-popup-body">
        <el-form
          :model="formData"
          :rules="rules"
          ref="formData"
          @submit.native.prevent
          label-position="top"
          class="itemAlter"
        >
          <el-form-item
            v-for="item in ruleProps"
            :key="item.prop"
            :label="item.label"
            :prop="item.prop"
          >
            <el-input
              v-if="item.type === 'textarea'"
              type="textarea"
              resize="none"
              v-model="formData[item.prop]"
              @keydown.enter.exact.prevent.stop.native="submitForm('formData')"
              @keyup.shift.enter.prevent.exact.stop.native
              :placeholder="item.placeholder"
            ></el-input>
            <el-input
              v-else
              v-model="formData[item.prop]"
              @keydown.enter.exact.prevent.stop.native="submitForm('formData')"
              :placeholder="item.placeholder"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="global_popup_footer">
        <button @click="submitForm('formData')">
          {{ $t("commonMsg.confirm") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    },

    ruleForm: {
      type: Object
    },

    ruleProps: {
      type: Array
    },

    rules: {
      type: Object
    }
  },
  computed: {
    formData() {
      this.data = Object.assign({}, this.ruleForm);
      return this.data;
    }
  },
  data() {
    return {
      data: null,
      height: ""
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$emit("addEvn", this.data);
        } else {
          return false;
        }
      });
    }
  },
  mounted() {
    this.height = `height: ${this.$refs.addPopup.clientHeight}px`;
  }
};
</script>

<style lang="scss">
.add-popup-component {
  @include globalPopup();
  .add-popup-container {
    background: #fff;
    border-radius: 4px;
  }
  .add-popup-body {
    padding: 0 60px;
  }
}
.el-form-item__label {
  /* margin-right: 20px; */
}
</style>
